import React, { useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { showModal } from "../../features/modal/modalSlice";
import moment from "moment";
import { setSelectedInspectionStation, setSelectedInspectionStationRoute } from "../../features/admin3/admin3Slice";
import { CiSquarePlus } from "react-icons/ci";

const Container = styled.div`
  width: 100%;
    .main {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      position: relative;
      background-color: ${({ theme }) => theme.secondaryBgColor};
      margin: 0;
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        text-align: center;
        gap: 15px;
        position: relative;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
          .location-item{
            display: flex;
            flex-direction: column;
            gap: 10px;
            border-bottom: 1px solid ${({ theme }) => theme.mainBgColor};
            padding-block: 10px;
            .row{
              display: flex;
              gap: 10px;
              span{
                font-weight: var(--font-weight-lg);
              }
              p{
                font-weight: var(--font-weight-sm);
              }
            }
          }
          
          .location-item:last-of-type{
            border-bottom: none;
          }
          .show-all{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
            text-decoration: underline;
            color: var(--color-main);
            cursor: pointer;
            margin-top: 10px;
          }
        }
      }
    }
`;

const AdminKarayollariKonumContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  const [showAll, setShowAll] = useState(false);

  const toggleShow = (e) => {
    e.stopPropagation()
    setShowAll(!showAll);
  }

  const locationList = showAll ? data.roadRouteLocations.$values : data.roadRouteLocations.$values.slice(0, 1);

  return (
    <Container onClick={() => {dispatch(setSelectedInspectionStationRoute(data)); dispatch(showModal("roadRouteOptions"))}}>
        <div className="main">
          <div className="row">
            <div className="col">{moment(data.createdAt).format("DD.MM.YYYY HH:mm")}</div>
            <div className="col">{data.name}</div>
            <div className="col">{data.startPoint}</div>
            <div className="col">{data.endPoint}</div>
            <div className="col">{locationList.map((item) => (
              <div className="location-item">
                <div className="row">
                  <span>Tip:</span>
                  <p>{item.type}</p>
                </div>
                <div className="row">
                  <span>Lat:</span>
                  <p>{item.latitude}</p>
                </div>
                <div className="row">
                  <span>Lng:</span>
                  <p>{item.longitude}</p>
                </div>
                <div className="row">
                  <span>Çap:</span>
                  <p>{item.radius}</p>
                </div>
                <div className="row">
                  <span>Uzaklık:</span>
                  <p>{item.distanceToStation}</p>
                </div>
                <div className="row">
                  <span>Mesaj:</span>
                  <p>{item.message}</p>
                </div>
              </div>
            ))}
              <div className="show-all">
                <span onClick={(e) =>toggleShow(e)}>{showAll ? "Gizle" : "Tümünü Göster"}</span>
              </div>
            </div>
          </div>
        </div>
    </Container>
  );
};

export default AdminKarayollariKonumContainer;
